import {
  createContext,
  ReactElement,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from "react";

const authContext = createContext<any>({});

const { Provider } = authContext;

const useAuthProvider = () => {
  const [user, setUser] = useState({});

  const values = useMemo(() => {
    return {
      user,
      setUser,
    };
  }, [user, setUser]);
  return values;
};

export const AuthProvider = ({
  children,
}: {
  children: ReactElement | ReactNode;
}) => {
  const auth = useAuthProvider();
  return <Provider value={auth}>{children}</Provider>;
};

export const useAuth = () => useContext(authContext);
